import { css, useTheme } from '@fable/theme'
import { useNavigate, useLocation } from 'react-router-dom'
import { FlexBox, Icon } from '@fable/components'
import { useActions, useTypedSelector, useSidebar } from '../../hooks/'

export const BooklistDelete = () => {
  const { colors } = useTheme()
  const { deleteBookList } = useActions()
  const { bookList } = useTypedSelector(({ books }) => books)
  const { onCloseSidebar } = useSidebar()

  const location = useLocation()
  const navigate = useNavigate()

  const handleDelete = async () => {
    await deleteBookList(bookList.data?.id)

    if (location.state) {
      const state = location.state as { prevPath: string }
      navigate(state.prevPath)
    }

    onCloseSidebar()
  }

  return (
    <div
      className={css`
        margin-top: 16px;
        padding-top: 12px;
        border-top: 1px solid ${colors.whiteSmoke};
      `}
    >
      <FlexBox
        className={css`
          cursor: pointer;
          width: 100px;
        `}
        alignItems="center"
        onClick={handleDelete}
      >
        <Icon
          className={css`
            margin-right: 8px;
            width: 20px;
          `}
          type="trash"
          fill={colors.mahogany}
        />
        <p
          className={css`
            color: ${colors.mahogany};
            font-size: 14px;
            line-height: 16px;
            font-weight: 600;
            cursor: inherit;
          `}
        >
          Delete
        </p>
      </FlexBox>
    </div>
  )
}
